export enum RehydrationTypes {
  MAP = 'map',
  MAP_WITH_MOMENT = 'mapWithMoment',
  OBJECT_MAP_CHILDREN = 'objectMapChildren',
  OBJECT_SET_CHILDREN = 'objectArrayChildren',
}
